import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import HowWeWork from '../components/HowWeWork';
import PricingSection from '../components/PricingSection';
import WhyChooseUs from '../components/WhyChooseUs';
import StatsSection from '../components/StatsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import ContactForm from '../components/ContactForm';
import { Toaster } from '../components/ui/toaster';

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      
      {/* Why You Need This */}
      <section className="py-20 bg-gradient-to-br from-[#C0392B] to-[#A93226] relative overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute top-10 right-10 w-64 h-64 bg-white/5 rounded-full blur-3xl" />
        <div className="absolute bottom-10 left-10 w-80 h-80 bg-white/5 rounded-full blur-3xl" />
        
        <div className="container mx-auto px-4 max-w-[1320px] relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Image */}
            <div className="relative animate-in fade-in slide-in-from-left duration-700">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[500px]">
                <img
                  src="https://images.pexels.com/photos/7875889/pexels-photo-7875889.jpeg?w=800"
                  alt="Professional trademark consultation and brand protection"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#C0392B]/30 to-transparent" />
              </div>
            </div>

            {/* Right Content */}
            <div className="space-y-6 animate-in fade-in slide-in-from-right duration-700 delay-200">
              <h2 className="text-4xl md:text-5xl font-bold text-white">
                Why Your Business Needs Trademark Protection
              </h2>
              <p className="text-xl text-white/90 leading-relaxed">
                In today's competitive marketplace, your brand is your most valuable asset. 
                Trademark registration provides legal protection for your business name, logo, and identity, 
                preventing others from using similar marks that could confuse customers or dilute your brand. 
                Without trademark protection, you risk losing your brand identity, facing costly legal disputes, 
                and missing opportunities for business growth. Our comprehensive trademark services ensure your 
                brand is protected at every stage of your business journey, giving you the confidence to build 
                and expand without fear of infringement or brand theft.
              </p>
            </div>
          </div>
        </div>
      </section>

      <ServicesSection />
      <HowWeWork />
      
      {/* Pricing Section */}
      <section className="py-20 bg-gradient-to-br from-white via-[#FDFEFE] to-white relative overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute top-0 right-0 w-72 h-72 bg-[#C0392B]/5 rounded-full blur-3xl -mr-20" />
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-[#7F8C8D]/5 rounded-full blur-3xl -ml-20" />
        
        <div className="container mx-auto px-4 max-w-[1320px] relative z-10">
          {/* Section Header */}
          <div className="text-center mb-16 space-y-4">
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C3E50]">
              Affordable Trademark Registration Packages
            </h2>
            <p className="text-xl text-[#2C3E50] max-w-3xl mx-auto">
              Choose the perfect package for your business needs. All packages include expert support and satisfaction guarantee.
            </p>
          </div>

          <PricingSection service="trademark-registration" />
        </div>
      </section>

      <WhyChooseUs />
      <StatsSection />
      <TestimonialsSection />
      <FAQSection />

      <Toaster />
    </div>
  );
};

export default Home;